import React, { useEffect, useRef, useState } from 'react';
import { mrbgStore } from './mrbgRedux/index.js'
import { formsJson } from '../../mrbgLib/formsJson.js'
import MrbgFormsCreator from './MrbgFormsCreator.jsx'
import mrbgS2S from '../../mrbgLib/mrbgS2S.js'
import { mrbgTools } from '../../mrbgLib/mrbgTools.js'

function MrbgTimeLineUpd_DT({formStyle}){

  const
    formRef = useRef(null),
    formID = 'timeLineUpd_DT',
    [formSettings,setFormSettings] = useState( mrbgStore.getState().formsSettings[formID] ),
    [showForm,setShowForm] = useState( false );

  function handleSubmit(){
    var MD = new FormData( document.getElementById(formStyle.timeLineUpd_DT) );
    mrbgS2S(formID, MD, 'updDate','apoSes')
  }

  useEffect( () => {
    if( showForm ){
      mrbgTools.triggerChange( formRef.current.querySelector('input[name="beginDateTime"]'), formSettings.sundryField.beginDateTime )
      if( formRef.current.querySelector('input[name="devID"][value="'+formSettings.sundryField.devID+'"]') )
        formRef.current.querySelector('input[name="devID"][value="'+formSettings.sundryField.devID+'"]').checked = true;
    }
  }, [showForm,formSettings] );
  useEffect(()=>{
    formSettings?.hideInp?.id && formSettings?.sundryField?.beginDateTime && formSettings?.sundryField?.devID?
      setShowForm(true):
      setShowForm(false);
  },[formSettings])
  useEffect(() => {
    const unsubscribe = mrbgStore.subscribe(()=>{
      setFormSettings( mrbgStore.getState().formsSettings[formID] )
    });
    return ()=>unsubscribe()
  }, []);

  if( !showForm )
    return '';

  return (
    <div id={formStyle.timeLineUpd_DTFrame} ref={formRef}>
      <div>
        <div onClick={()=>handleSubmit()}>Update</div>
        <i className="fa-solid fa-close" onClick={()=>document.getElementById(formStyle.timeLineUpd_DT).mrbgReset()}></i>
      </div>
      <MrbgFormsCreator {...{formID,...formsJson.EP.apoSes.forms[formID],formStyle}}/>
    </div>
  )
}

export default MrbgTimeLineUpd_DT;